<template>
  <div class="p-grid p-fluid">
    <div class="p-lg-4 p-col-12 dashboard" v-if="isUserTemPerssao('holerite')">
      <router-link :to="{ name: 'holerite' }">
        <div class="summary-box summary-box-azul">
          <Card class="card">
            <template slot="content">
              <p class="summary-box-title">Holerite</p>
              <p>&nbsp;</p>
              <img
                src="../../public/assets/layout/images/tmp/graph-messages.svg"
                alt="sapphire"
                class="summary-box-graph"
              />
              <i class="pi pi-money-bill summary-box-icon ico"></i>
            </template>
          </Card>
        </div>
      </router-link>
    </div>
    <div class="p-lg-4 p-col-12 dashboard" v-if="isUserTemPerssao('cedulac')">
      <router-link :to="{ name: 'cedulac' }">
        <div class="summary-box summary-box-amarelo">
          <Card class="card">
            <template slot="content">
              <p class="summary-box-title">Cédula C</p>
              <p>&nbsp;</p>
              <img
                data-v-b29879e6=""
                src="../../public/assets/layout/images/tmp/graph-messages.svg"
                alt="sapphire"
                class="summary-box-graph"
              />
              <i class="pi pi-chart-bar summary-box-icon ico"></i>
            </template>
          </Card>
        </div>
      </router-link>
    </div>

    <div class="p-lg-4 p-col-12 dashboard" v-if="isUserTemPerssao('fichafinanceira')">
      <router-link :to="{ name: 'fichafinanceira' }">
        <div class="summary-box summary-box-ficha-financeira">
          <Card class="card">
            <template slot="content">
              <p class="summary-box-title">Fichas Financeiras</p>
              <p>&nbsp;</p>

              <img
                data-v-b29879e6=""
                src="../../public/assets/layout/images/tmp/graph-messages.svg"
                alt="sapphire"
                class="summary-box-graph"
              />
              <i class="pi pi-book summary-box-icon ico"></i>
            </template>
          </Card>
        </div>
      </router-link>
    </div>

    <div class="p-lg-4 p-col-12 dashboard"   v-if="isUserTemPerssao('dadosPessoaisServidor')" >
      <router-link :to="{ name: 'dadosPessoaisServidor' }">
        <div class="summary-box summary-box-lilas">
          <Card class="card">
            <template slot="content">
              <p class="summary-box-title">Dados Pessoais</p>
              <p>&nbsp;</p>
              <img
                data-v-b29879e6=""
                src="../../public/assets/layout/images/tmp/graph-messages.svg"
                alt="sapphire"
                class="summary-box-graph"
              />
              <i class="pi pi-user summary-box-icon ico"></i>
            </template>
          </Card>
        </div>
      </router-link>
    </div>

    <div class="p-lg-4 p-col-12 dashboard" v-if="isUserTemPerssao('retratoFuncional')" >
      <router-link :to="{ name: 'retratoFuncional' }">
        <div class="summary-box summary-box-roxo">
          <Card class="card">
            <template slot="content">
              <p class="summary-box-title">Retrato</p>
              <p>FUNCIONAL</p>
              <img
                data-v-b29879e6=""
                src="../../public/assets/layout/images/tmp/graph-messages.svg"
                alt="sapphire"
                class="summary-box-graph"
              />
              <i class="pi pi-copy summary-box-icon ico"></i>
            </template>
          </Card>
        </div>
      </router-link>
    </div>
    <!--
		<div class="p-lg-4 p-col-12 dashboard" >
            <router-link :to="{name: 'dashboard'}">
                <div class="summary-box summary-box-cinza" >
                    <Card class=" card" >
                        <template slot="content">
                            <p class="summary-box-title">Histórico</p>
                            <p>FUNCIONAL</p>
                            <img data-v-b29879e6="" src="../../public/assets/layout/images/tmp/graph-messages.svg" alt="sapphire" class="summary-box-graph">
                            <i class="pi pi-id-card summary-box-icon ico"></i>
                        </template>
                    </Card>
                </div>
            </router-link>        
        </div>
-->
    <div class="p-lg-4 p-col-12 dashboard"  v-if="isUserTemPerssao('contribuicaoPrevidenciaria') && tipoVinculo != 'Contratado Temporário'" >
      <router-link :to="{ name: 'contribuicaoPrevidenciaria' }">
        <div class="summary-box summary-box-verde">
          <Card class="card">
            <template slot="content">
              <p class="summary-box-title">Extrato Previdenciário</p>
              <p>Serviços</p>
              <img
                data-v-b29879e6=""
                src="../../public/assets/layout/images/tmp/graph-messages.svg"
                alt="sapphire"
                class="summary-box-graph"
              />
              <i class="pi pi-dollar summary-box-icon ico"></i>
            </template>
          </Card>
        </div>
      </router-link>
    </div>

    <div class="p-lg-4 p-col-12 dashboard" v-if="isUserTemPerssao('mtPrev')">
      <router-link :to="{ name: 'mtPrev' }">
        <div
          class="summary-box summary-box-verdePervia"
          style="cursor: pointer"
        >
          <Card class="card">
            <template slot="content">
              <p class="summary-box-title">Previdenciário</p>
              <p>Portal de serviços do MTPrev</p>
              <img
                data-v-b29879e6=""
                src="../../public/assets/layout/images/tmp/graph-messages.svg"
                alt="sapphire"
                class="summary-box-graph"
              />
              <i class="pi pi-bars summary-box-icon ico"></i>
            </template>
          </Card>
        </div>
      </router-link>
    </div>

    <div class="p-lg-4 p-col-12 dashboard" v-if="isUserTemPerssao('feriasServidor')" >
      <router-link :to="{ name: 'feriasServidor' }">
        <div class="summary-box summary-box-vermelho">
          <Card class="card">
            <template slot="content">
              <p class="summary-box-title">Férias</p>
              <p>&nbsp;</p>
              <img
                data-v-b29879e6=""
                src="../../public/assets/layout/images/tmp/graph-messages.svg"
                alt="sapphire"
                class="summary-box-graph"
              />
              <i class="pi pi-briefcase summary-box-icon ico"></i>
            </template>
          </Card>
        </div>
      </router-link>
    </div>
    <div class="p-lg-4 p-col-12 dashboard" v-if="isUserTemPerssao('licencaPremioServidor')" >
      <router-link :to="{ name: 'licencaPremioServidor' }">
        <div class="summary-box summary-box-laranja">
          <Card class="card">
            <template slot="content">
              <p class="summary-box-title">Licença Prêmio</p>
              <p>&nbsp;</p>
              <img
                data-v-b29879e6=""
                src="../../public/assets/layout/images/tmp/graph-messages.svg"
                alt="sapphire"
                class="summary-box-graph"
              />
              <i class="pi pi-images summary-box-icon ico"></i>
            </template>
          </Card>
        </div>
      </router-link>
    </div>
    <div v-if="isUserTemPerssao('certidoes')" class="p-lg-4 p-col-12 dashboard">
      <router-link :to="{ name: 'certidoes' }">
        <div class="summary-box summary-box-cinza">
          <Card class="card">
            <template slot="content">
              <p class="summary-box-title">Certidões</p>
              <p>&nbsp;</p>
              <img
                data-v-b29879e6=""
                src="../../public/assets/layout/images/tmp/graph-messages.svg"
                alt="sapphire"
                class="summary-box-graph"
              />
              <i class="pi pi-file summary-box-icon ico"></i>
            </template>
          </Card>
        </div>
      </router-link>
    </div>
    <!-- v-if="isUserTemPerssao('avaliacao')" -->
    <!-- <div class="p-lg-4 p-col-12 dashboard">
            <router-link :to="{name: 'avaliacao'}">
                <div class="summary-box summary-box-marron" >
                    <Card class=" card" >
                        <template slot="content">
                            <p class="summary-box-title">Avaliações</p> 
                            <p>&nbsp;</p>
                            <img data-v-b29879e6="" src="../../public/assets/layout/images/tmp/graph-messages.svg" alt="sapphire" class="summary-box-graph">
                            <img src="../assets/user_star_gray.png" class=" pi summary-box-icon ico">
                        </template>
                    </Card>
                </div>
            </router-link>      
        </div>  -->
    <div class="p-lg-4 p-col-12 dashboard" v-if="isUserTemPerssao('declaracaobens')">
      <a href="/declaracaobens" target="_BLANK">
        <div class="summary-box summary-box-azulescuro">
          <Card class="card">
            <template slot="content">
              <p class="summary-box-title">Bens e Valores</p>
              <p>Declaração anual</p>
              <img
                data-v-b29879e6=""
                src="../../public/assets/layout/images/tmp/graph-messages.svg"
                alt="sapphire"
                class="summary-box-graph"
              />
              <img
                class="summary-box-icon ico"
                style="opacity: 0.7;"
                width="70"
                data-v-b29879e6=""
                src="../../public/assets/layout/images/tmp/piggy-bank.svg"
                alt="sapphire"
              />
            </template>
          </Card>
        </div>
      </a>
    </div>

    <div class="p-lg-4 p-col-12 dashboard"  v-if="isUserTemPerssao('recadastramento')">
      <a href="/recadastramento" target="_BLANK">
        <div class="summary-box summary-box-recad">
          <Card class="card">
            <template slot="content">
              <p class="summary-box-title">Recadastramento</p>
              <p>&nbsp;</p>
              <img
                data-v-b29879e6=""
                src="../../public/assets/layout/images/tmp/graph-messages.svg"
                alt="sapphire"
                class="summary-box-graph"
              />
              <img
                class="summary-box-icon ico"
                style="filter: opacity(0.7)"
                width="75"
                data-v-b29879e6=""
                src="../../public/assets/layout/images/tmp/icon-recad.svg"
                alt="sapphire"
              />
            </template>
          </Card>
        </div>
      </a>
    </div>

    <div class="p-lg-4 p-col-12 dashboard"  v-if="isUserTemPerssao('sga')">
      <!-- <router-link :to="{ name: 'sga' }"> -->
      <a :href="sgaUrl" target="_blank">
        <div class="summary-box summary-box-sga">
          <Card class="card">
            <template slot="content">
              <p class="summary-box-title">Perícia Médica</p>
              <p>Agendamento de Perícia Médica</p>
              <img
                data-v-b29879e6=""
                src="../../public/assets/layout/images/tmp/graph-messages.svg"
                alt="sapphire"
                class="summary-box-graph"
              />
              <i class="pi pi-calendar summary-box-icon ico"></i>
            </template>
          </Card>
        </div>
      </a>
      <!-- </router-link> -->
    </div>

    <div class="p-lg-4 p-col-12 dashboard"  v-if="isUserTemPerssao('carteiraFuncional')">
      <div
        class="summary-box summary-box-cfd"
        @click="gerarCarteiraFuncional"
      >
        <Card class="card">
          <template slot="content">
            <p class="summary-box-title">Carteira Funcional Digital</p>
            <p>&nbsp;</p>
            <img
              data-v-b29879e6=""
              src="../../public/assets/layout/images/tmp/graph-messages.svg"
              alt="sapphire"
              class="summary-box-graph"
            />
            <img
              class="summary-box-icon ico"
              style="filter: opacity(0.7)"
              data-v-b29879e6=""
              src="../../public/assets/layout/images/tmp/icon-cracha.png"
              alt="sapphire"
            />
          </template>
        </Card>
      </div>
    </div>
    <div class="p-lg-4 p-col-12 dashboard" v-if="isUserTemPerssao('cracha')">
      <div
        class="summary-box summary-box-cracha"
        @click="gerarCrachaDigital"
      >
        <Card class="card">
          <template slot="content">
            <p class="summary-box-title">Crachá</p>
            <p>&nbsp;</p>
            <img
              data-v-b29879e6=""
              src="../../public/assets/layout/images/tmp/graph-messages.svg"
              alt="sapphire"
              class="summary-box-graph"
            />
            <img
              class="summary-box-icon ico"
              style="filter: opacity(0.7)"
              data-v-b29879e6=""
              src="../../public/assets/layout/images/tmp/icon-cracha.png"
              alt="sapphire"
            />
          </template>
        </Card>
      </div>
    </div>
    
    <div class="p-lg-4 p-col-12 dashboard"  v-if="isUserTemPerssao('tabelaSalarial')">
      <div class="summary-box summary-box-tabela-salarial" @click="redirectTabelaSalarial" >
        <Card class="card">
          <template slot="content">
            <p class="summary-box-title">Tabela Salarial</p>
            <p>&nbsp;</p>
            <img
              data-v-b29879e6=""
              src="../../public/assets/layout/images/tmp/graph-messages.svg"
              alt="sapphire"
              class="summary-box-graph"
            />
            <img
              class="summary-box-icon ico"
              style="filter: opacity(0.7)"
              data-v-b29879e6=""
              src="../../public/assets/layout/images/tmp/TABELA_SALARIAL_ICON.svg"
              alt="sapphire"
            />
          </template>
        </Card>
      </div>
      <!-- </a> -->
    </div>

    <div class="p-lg-4 p-col-12 dashboard"  v-if="isUserTemPerssao('cat')">
      <a href="/cat" target="_BLANK">
        <div class="summary-box summary-box-cat">
          <Card class="card">
            <template slot="content">
              <p class="summary-box-title">CAT</p>
              <p class="subtitle-box">Comunicação de Acidente de Trabalho</p>
              <img
                data-v-b29879e6=""
                src="../../public/assets/layout/images/tmp/graph-messages.svg"
                alt="sapphire"
                class="summary-box-graph"
              />
              <img
                alt="capacete"
                src="../assets/CAT_Estranho.svg"
                style="width: 85px; filter: opacity(0.7)"
                class="summary-box-icon ico"
              />
            </template>
          </Card>
        </div>
      </a>
    </div>    
    <div class="p-lg-4 p-col-12 dashboard"  v-if="isUserTemPerssao('solicitaVerba')">
      <router-link :to="{ name: 'solicitaVerba' }">
        <div class="summary-box summary-box-verde">
          <Card class="card">
            <template slot="content">
              <p class="summary-box-title">Professores Temporários</p>
              <p>Indenização de Férias e Adicional de 1/3</p>
              <img
                data-v-b29879e6=""
                src="../../public/assets/layout/images/tmp/graph-messages.svg"
                alt="sapphire"
                class="summary-box-graph"
              />
              <i class="pi pi-dollar summary-box-icon ico"></i>
            </template>
          </Card>
        </div>
      </router-link>
    </div>
    <div class="p-lg-4 p-col-12 dashboard"  v-if="$store.getters.getSituacaoFuncionario === 'ATIVO'">
      <a :href="psiUrl" target="_blank">
        <div class="summary-box summary-box-psi">
          <Card class="card">
            <template slot="content">
              <p class="summary-box-title">Serviços de Saúde</p>
              <p>Agende sua sessão psicológica gratuita</p>
              <img
                data-v-b29879e6=""
                src="../../public/assets/layout/images/tmp/graph-messages.svg"
                alt="sapphire"
                class="summary-box-graph"
              />
              <i class="fas fa-user-md summary-box-icon ico"></i>
            </template>
          </Card>
        </div>
      </a>
    </div>

    <CardExibirPDF
      v-if="pdfElement && navegador != 'Safari'"
      v-model="exibirPDF"
      :nomeDocumento="nomeDocumentoPDF"
      :tituloTela=tituloCard
      :position="'top'"
      :tamanhoTela="'55.em'"
      :alturaTela="'55.em'"
      :pdfElement="pdfElement"
      :blockPrint="true"
      :alteraToolbar="true"
    />
  </div>
</template>

<script>
import { baseApiUrl } from "@/config/global";
import { baseApiUrlCracha } from "@/config/global";
import CardExibirPDF from "@/template/CardExibirPDF.vue";
import { detectaNavegador, isUserTemPerssaoGlobal } from '../config/global';

export default {
  name: "dashboard",
  components: { CardExibirPDF },
  computed: {
    sgaUrl() {
      return process.env.VUE_APP_API_URL_SGA;
    },
    psiUrl() {
      return process.env.VUE_APP_API_URL_PSI;
    }
  },
  data: function () {
    return {
      tipoVinculo: "Contratado Temporário",
      exibirPDF: false,
      nomeDocumentoPDF: "holerite",
      pdfElement: null,
      navegador: null,
      telaComFoco: true,
      tituloCard:"Carteira Funcional Digital"
    };
  },
  methods: {
    isUserTemPerssao(nomerota) {
      if (process.env.VUE_APP_AMBIENTE != "DESENVOLVIMENTO") {
        switch (nomerota) {
          case "avaliacao":
            return false;
        }
      }
      if(nomerota == 'cfd'){
        let nroVinculoSelecionado =this.$store.getters.getVinculo;
        let listaVinculos = this.$store.getters.getUser.dadosUsuariosCustomizados.listaVinculos;
        let vinculoSelecionado =
            listaVinculos.filter(
              function (element) {
                return element.vinculo == nroVinculoSelecionado && element.situacaoFuncionario=='ATIVO';
              }
            );
        return vinculoSelecionado.length>0;
      }
      return isUserTemPerssaoGlobal(nomerota);
    },

    atualizarFoto() {
			this.$store.commit("setAbrirModalTrocaFoto",!this.$store.getters.getExibirModalTrocaFoto)  
    },

    mtPrev() {
      let dadosMTPrev = {
        Matricula: this.$store.getters.getMatricula,
        Cpf: this.$store.getters.getUser.contaAcesso.pessoa.numrCpf,
      };
      this.$http
        .post(`${baseApiUrl}/mtprev/linkacesso`, JSON.stringify(dadosMTPrev))
        .then((res) => {
          window.location.href = res.data;
        });
    },
    gerarCarteiraFuncional() {
      let nroVinculoSelecionado = this.$store.getters.getVinculo;
      let listaVinculos =
        this.$store.getters.getUser.dadosUsuariosCustomizados.listaVinculos;
      let vinculoSelecionado = listaVinculos.filter(function (element) {
        return element.vinculo == nroVinculoSelecionado;
      });
      this.$http.get(`${baseApiUrlCracha}/cfd/gerar/${vinculoSelecionado[0].matricula}/${vinculoSelecionado[0].vinculo}`).then((res) => {
          
          
            this.pdfElement = res.data.dadosRelatorioBase64;
            this.nomeDocumentoPDF = res.data.nomeArquivo;
            this.exibirPDF = true;
            this.tituloCard= "Carteira funcional digital"
  
            const byteCharacters = atob(res.data.dadosRelatorioBase64);
            const byteNumbers = new Array(byteCharacters.length);
  
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
  
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/pdf" });
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, "carteirafuncional.pdf");
            } else {
              const objectUrl = URL.createObjectURL(blob);
  
              const link = document.createElement("a");
              link.href = objectUrl;
              link.download = "carteirafuncional.pdf";
              link.style.display = "none";
  
              if (detectaNavegador() === 4) {
                this.exibirPDF = false;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
  
                setTimeout(() => {
                  window.open(objectUrl, "_blank");
                }, 1000);
              }
  
              setTimeout(() => {
                URL.revokeObjectURL(objectUrl);
              }, 2000);
            }

        
        });
    },
    redirectTabelaSalarial() {
      window.open(window.location.href+"/publico/tabela-salarial", "_blank");
    },
    gerarCrachaDigital() {
      let nroVinculoSelecionado = this.$store.getters.getVinculo;
      let listaVinculos =
        this.$store.getters.getUser.dadosUsuariosCustomizados.listaVinculos;
      let vinculoSelecionado = listaVinculos.filter(function (element) {
        return element.vinculo == nroVinculoSelecionado;
      });
      this.$http.get(`${baseApiUrlCracha}/cfd/gerarCracha/${vinculoSelecionado[0].matricula}/${vinculoSelecionado[0].vinculo}`).then((res) => {
          
          
            this.pdfElement = res.data.dadosRelatorioBase64;
            this.nomeDocumentoPDF = res.data.nomeArquivo;
            this.exibirPDF = true;
            this.tituloCard= "Crachá"
            
  
            const byteCharacters = atob(res.data.dadosRelatorioBase64);
            const byteNumbers = new Array(byteCharacters.length);
  
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
  
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/pdf" });
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, "cracha.pdf");
            } else {
              const objectUrl = URL.createObjectURL(blob);
  
              const link = document.createElement("a");
              link.href = objectUrl;
              link.download = "cracha.pdf";
              link.style.display = "none";
  
              if (detectaNavegador() === 4) {
                this.exibirPDF = false;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
  
                setTimeout(() => {
                  window.open(objectUrl, "_blank");
                }, 1000);
              }
  
              setTimeout(() => {
                URL.revokeObjectURL(objectUrl);
              }, 2000);
            }

        
        });
    }
  },

  mounted() {
    this.tipoVinculo =
      this.$store.getters.getUser.dadosUsuariosCustomizados.vinculoSeap.tipoVinculo;
     
   document.addEventListener('keyup', (e) => {
    if (e.key == 'PrintScreen') {
        navigator.clipboard.writeText('');
        alert('PrintScreen desabilitado!');
    }
});
      
  },
};
</script>

<style scoped>
.dashboard > div {
  padding: 0em;
}

.dashboard .dashboard-grid {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding: 0;
}

.dashboard .card {
  height: 100%;
  margin-bottom: 30px;
  border-radius: 25px;
}

.dashboard .summary-box {
  position: relative;
}

.dashboard .summary-box .card {
  min-height: 100px;
}

.dashboard .summary-box .summary-box-title {
  font-size: 2em;
  margin: 0;
  color: #ffffff;
}

.dashboard .summary-box p {
  margin: 0.25em 0;
  color: #ffffff;
}

.dashboard .summary-box .summary-box-icon {
  position: absolute;
  font-size: 5em;
  right: 24px;
  top: 32px;
}

.dashboard .summary-box .summary-box-graph {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

.dashboard .summary-box.summary-box-azul .card {
  border-top: 4px solid #0097a7;
  background-color: #00bcd4;
}

.dashboard .summary-box.summary-box-azul .ico {
  color: #0097a7;
}

.dashboard .summary-box.summary-box-rosa .card {
  border-top: 4px solid #ad1457;
  background-color: #e91e63;
}

.dashboard .summary-box.summary-box-rosa .ico {
  color: #ad1457;
}

.dashboard .summary-box.summary-box-amarelo .card {
  border-top: 4px solid #f47b08;
  background-color: #ffb300;
}

.dashboard .summary-box.summary-box-amarelo .ico {
  color: #f47b08;
}

.dashboard .summary-box.summary-box-cinza .card {
  border-top: 4px solid #455a64;
  background-color: #607d8b;
}

.dashboard .summary-box.summary-box-cinza .ico {
  color: #455a64;
}

.dashboard .summary-box.summary-box-verde .card {
  border-top: 4px solid #004000;
  background-color: #00b22d;
}

.dashboard .summary-box.summary-box-verde .ico {
  color: #256029;
}

.dashboard .summary-box.summary-box-verdePervia .card {
  border-top: 4px solid #004000;
  background-color: #0e5e24;
}

.dashboard .summary-box.summary-box-verdePervia .ico {
  color: #256029;
}

.dashboard .summary-box.summary-box-lilas .card {
  border-top: 4px solid #300a30;
  background-color: #a57fa5;
}

.dashboard .summary-box.summary-box-lilas .ico {
  color: #300a30;
}

.dashboard .summary-box.summary-box-laranja .card {
  border-top: 4px solid #6d3700;
  background-color: #ee7600;
}

.dashboard .summary-box.summary-box-laranja .ico {
  color: #6d3700;
}

.dashboard .summary-box.summary-box-roxo .card {
  border-top: 4px solid #371743;
  background-color: #8c2d7e;
}

.dashboard .summary-box.summary-box-roxo .ico {
  color: #371743;
}

.dashboard .summary-box.summary-box-vermelho .card {
  border-top: 4px solid #660000;
  background-color: #ff2626;
}

.dashboard .summary-box.summary-box-vermelho .ico {
  color: #660000;
}

.dashboard .summary-box.summary-box-azulescuro .card {
  border-top: 4px solid #5367a1;
  background-color: #0085b2;
}

.dashboard .summary-box.summary-box-azulescuro .ico {
  color: #5367a1;
}

.dashboard .summary-box.summary-box-marron .card {
  border-top: 4px solid #8b4513;
  background-color: #8b5742;
}

.dashboard .summary-box.summary-box-marron .ico {
  width: 13% !important;
  opacity: 0.7;
}

.dashboard .summary-box.summary-box-recad .card {
  border-top: 4px solid hwb(25 10% 39%);
  background-color: #915c47;
}

.dashboard .summary-box.summary-box-recad .ico {
  width: 13% !important;
  opacity: 0.7;
}

.dashboard .summary-box-tabela-salarial {
  cursor: pointer;
}

.dashboard .summary-box.summary-box-tabela-salarial .card {
  border-top: 4px solid #a58c4e;
  background-color: #d1a128;
}

.dashboard .summary-box-cfd {
  cursor: pointer;
}

.dashboard .summary-box.summary-box-cfd .card {
  border-top: 4px solid #89b487;
  background-color: #358830;
}

.dashboard .summary-box-cracha {
  cursor: pointer;
}

.dashboard .summary-box.summary-box-cracha .card {
  border-top: 4px solid #5eb65a;
  background-color: #89b487;
}

.dashboard .summary-box.summary-box-cracha .ico {
  width: 13% !important;
  opacity: 0.7;
}


.dashboard .summary-box.summary-box-tabela-salarial .ico {
  width: 20% !important;
}

.dashboard .summary-box.summary-box-psi .card {
  border-top: 4px solid #430e88;
  background-color: #c09cee;
}

.dashboard .summary-box.summary-box-psi .ico {
  color: #580451;
  /* width: 13% !important; */
  /* opacity: 0.7; */
}

.dashboard .summary-box.summary-box-sga .card {
  border-top: 4px solid #b3cccc;
  background-color: #b3cccc;
}

.dashboard .summary-box.summary-box-sga .ico {
  color: #292727;
  /* width: 13% !important; */
  /* opacity: 0.7; */
}

.dashboard .summary-box.summary-box-ficha-financeira .card {
  border-top: 4px solid #25c1b5;
  background-color: #00bcd4;
}

.dashboard .summary-box.summary-ficha-financeira .ico {
  color: #25c1b5;
}

.dashboard .summary-box.summary-box-cat .card {
  border-top: 4px solid #5a3e7e;
  background-color: #9961e2;
}

@media (max-width: 900px) and (min-width: 1199px) {
  .dashboard .summary-box.summary-box-cat .subtitle-box {
    font-size: 0.7rem;
  }
}

@media (max-width: 1500px) and (min-width: 1200px) {
  .dashboard .summary-box.summary-box-cat .subtitle-box {
    font-size: 0.9rem;
  }
}

/* subtitle-box */

/* STATUS DE VALIDAÇÃO DA CHEFIA*/
.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5em;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
}

.status-Aceito {
  background-color: #c8e6c9;
  color: #256029;
}

.status-Pendente {
  background-color: #ffcdd2;
  color: #c63737;
}

.status-negotiation {
  background-color: #feedaf;
  color: #8a5340;
}

.status-new {
  background-color: #b3e5fc;
  color: #23547b;
}

.status-renewal {
  background-color: #eccfff;
  color: #694382;
}

.status-proposal {
  background-color: #ffd8b2;
  color: #805b36;
}

/* status */
.status-Usufruido {
  font-weight: bold;
  color: #23547b;
}

.status-Agendado {
  font-weight: bold;
  color: #256029;
}

.status-Aguardando {
  font-weight: bold;
  color: yellowgreen;
}
</style>